export default __webpack_public_path__ + "403.svg";